export default __webpack_public_path__ + "static/media/Icon_Document.110c7c6f.svg";